'use strict';

import {userPrevent} from "../../functions";

export class Drag {
  constructor(element, parameters = {}) {
    this.element = typeof (element) === 'string' ? document.querySelector(element) : element;
    this.active = false;
    this.currentX = null;
    this.currentY = null;
    this.initialX = null;
    this.initialY = null;
    this.xOffset = 0;
    this.yOffset = 0;
    this.onDragStart = (e) => {};
    this.onDragEnd = (e) => {};
    this.dragMoveHandler = (e) => this.dragMove(e);
    this.dragUpHandler = (e) => this.dragUp(e);
    this.touchSupport = parameters.hasOwnProperty('touchSupport') ? parameters['touchSupport'] : false;
    this.updateElementPositionAfterDragEnd = parameters.hasOwnProperty('updateElementPositionAfterDragEnd') ? parameters['updateElementPositionAfterDragEnd'] : false;

    this.element.style.cursor = 'grab';
    this.element.style.touchAction = 'none';

    this.element.addEventListener('mousedown', this.dragStart.bind(this));

    if (this.touchSupport) {
      this.element.addEventListener('touchstart', this.dragStart.bind(this));
    }
  }

  dragStart(evt) {
    evt.preventDefault();
    if (userPrevent()) return;
    for (let child of this.element.children) {
      child.style.cursor = 'grabbing';
    }
    this.element.style.cursor = 'grabbing';
    if (evt.type === 'touchstart' && this.touchSupport) {
      this.initialX = evt.touches[0].clientX - this.xOffset;
      this.initialY = evt.touches[0].clientY - this.yOffset;
      this.clickX = evt.touches[0].clientX;
      this.clickY = evt.touches[0].clientY;
      this.active = true;

      document.addEventListener('touchmove',this.dragMoveHandler);
      this.element.addEventListener('touchend',this.dragUpHandler);
    } else {
      this.initialX = evt.clientX - this.xOffset;
      this.initialY = evt.clientY - this.yOffset;
      this.clickX = evt.clientX;
      this.clickY = evt.clientY;
      this.active = true;

      document.addEventListener('mousemove',this.dragMoveHandler);
      this.element.addEventListener('mouseup',this.dragUpHandler);
    }
    this.onDragStart(evt);
  }

  dragMove(evt) {
    evt.preventDefault();
    if (userPrevent()) return;
    if (this.active) {
      if (evt.type === 'touchmove' && this.touchSupport) {
        this.currentX = evt.touches[0].clientX - this.initialX;
        this.currentY = evt.touches[0].clientY - this.initialY;
      } else {
        this.currentX = evt.clientX - this.initialX;
        this.currentY = evt.clientY - this.initialY;
      }

      this.xOffset = this.currentX;
      this.yOffset = this.currentY;

      if (this.element.style.animation) {
        this.element.style.animation = '';
      }

      this.element.style.transform = "translate3d(" + this.currentX + "px, " + this.currentY + "px, 0)";

      for (let child of this.element.children) {
        child.style.userSelect = 'none';
        child.style.pointerEvents = 'none';
      }
    }
  }

  dragUp(evt) {
    this.element.style.cursor = 'grab';
    this.initialX = this.currentX;
    this.initialY = this.currentY;
    this.active = false;

    for (let child of this.element.children) {
      child.style.userSelect = '';
      child.style.pointerEvents = '';
      child.style.cursor = '';
    }

    if (this.updateElementPositionAfterDragEnd) {
      this.element.style.left = parseFloat(this.element.style.left) + this.xOffset + 'px';
      this.element.style.top = parseFloat(this.element.style.top) + this.yOffset + 'px';
      this.element.style.transform = '';
      this.xOffset = 0;
      this.yOffset = 0;
    }
  
    this.onDragEnd(evt);
    this.removeEventListeners();
  }

  removeEventListeners() {
    document.removeEventListener('mousemove',this.dragMoveHandler);
    document.removeEventListener('touchmove',this.dragMoveHandler);
    this.element.removeEventListener('mouseup',this.dragUpHandler);
    this.element.removeEventListener('touchend',this.dragUpHandler);
  }

}
